import type { RouteWaypoint } from "../../../ReviewPage/hooks/useCircuitCablePaths/types";
import type { TrayTypeAlongPath } from "./types";

const distanceToSegment = (p: RouteWaypoint, a: RouteWaypoint, b: RouteWaypoint): number => {
  const abx = b.x - a.x;
  const aby = b.y - a.y;
  const len2 = abx * abx + aby * aby;
  const t = len2 === 0 ? 0 : Math.max(0, Math.min(1, ((p.x - a.x) * abx + (p.y - a.y) * aby) / len2));
  return Math.hypot(p.x - (a.x + t * abx), p.y - (a.y + t * aby));
};

// The router's own rule: both ends AND the midpoint on one drawn tray, or a chord that leaves it would pass.
export const trayTypeAlongPath: TrayTypeAlongPath = ({ waypoints, trays, tolerance }) =>
  waypoints.slice(1).map((to, index) => {
    const from = waypoints[index];
    const mid = { x: (from.x + to.x) / 2, y: (from.y + to.y) / 2 };
    const ridden = trays.find((tray) =>
      [from, to, mid].every((point) => distanceToSegment(point, tray.from, tray.to) < tolerance),
    );
    return ridden ? ridden.type : null;
  });
